// 接続用ホストの取得
const HOST = process.env.API_HOST

export default HOST



// WEBPACK FOOTER //
// ./src/api/hosts.js